module.exports = {
  "PUBLIC_ANDROID_APP_ID": "com.gpm.fortis.treefort.app",
  "PUBLIC_API_DOMAIN_NAME": "api.fortisplus.org",
  "PUBLIC_API_DOMAIN_NAME_WEB": "",
  "PUBLIC_API_ENDPOINT": "",
  "PUBLIC_APPLE_ID": "6689522814",
  "PUBLIC_APP_ID": "249",
  "PUBLIC_APP_NAME": "Fortis+",
  "PUBLIC_AUTH_DOMAIN_NAME": "auth.treefortsystems.com",
  "PUBLIC_AUTH_ENDPOINT": "https://fortisplus.org",
  "PUBLIC_CDN_ENDPOINT": "https://cdn2.treefortsystems.com",
  "PUBLIC_CLIENT_ID_WEB": "234d6be7-721f-4628-81df-dbfce8cbf10f",
  "PUBLIC_DEBUG": "",
  "PUBLIC_DOMAIN_NAME": "fortisplus.org",
  "PUBLIC_EAS_PROJECT_ID": "713ac9a1-615c-4a21-ab3f-97c760c3feca",
  "PUBLIC_EAS_UPDATE_CHANNEL": "prd_gpm",
  "PUBLIC_ENV": "production",
  "PUBLIC_FIREBASE_CONFIG_WEB": "eyJhcHBJZCI6IjE6MzA4NzY2MjU5MDY6d2ViOmUyMmQ1YjM1ODkxMzc5YzYxMDE5NmIiLCJhcGlLZXkiOiJBSXphU3lDXzR2UW9IMDBIdzJxVTFfVUZwdjFzU2lLNHYwNGU1RzQiLCJwcm9qZWN0SWQiOiJmb3J0aXMtc3RyZWFtaW5nLWQ1NDQ2IiwiYXV0aERvbWFpbiI6ImZvcnRpcy1zdHJlYW1pbmctZDU0NDYuZmlyZWJhc2VhcHAuY29tIiwibWVhc3VyZW1lbnRJZCI6IkctRzFQOVpUUkM5QiIsInN0b3JhZ2VCdWNrZXQiOiJmb3J0aXMtc3RyZWFtaW5nLWQ1NDQ2LmFwcHNwb3QuY29tIiwibWVzc2FnaW5nU2VuZGVySWQiOiIzMDg3NjYyNTkwNiJ9",
  "PUBLIC_FIREBASE_MESSAGING_VAPID_PUBLIC_KEY": "BFqCEpgmLaXH39OGrcVwR0sZ28aIc1XyzBPuGOx-Y8-ol11O734SwlZgr81t3FL8fa2_HDdFf4Jpa_WVzOslFEU",
  "PUBLIC_GOOGLE_SITE_VERIFICATION_TOKEN": "",
  "PUBLIC_ICON_BACKGROUND_COLOR": "#001f00",
  "PUBLIC_ICON_FOREGROUND_IMAGE_PADDING": "50",
  "PUBLIC_ICON_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/aba53a40-4ca8-4f37-b1a3-66ba1169d1b4/uploads/6ed94c5b-93c6-46fe-b96f-0338b3038616.png",
  "PUBLIC_IOS_BUNDLE_ID": "com.gpm.fortis.treefort.app",
  "PUBLIC_MANIFEST_URL": "",
  "PUBLIC_META_PIXEL_ID": "",
  "PUBLIC_OBJECT_STORAGE_CDN_ENDPOINT": "https://cdn.treefortsystems.com/file/treefort-ott-prod",
  "PUBLIC_PASSWORDLESS": "disabled",
  "PUBLIC_REGION_ENDPOINT": "https://media.treefortsystems.com/region",
  "PUBLIC_RUDDERSTACK_WRITE_KEY_WEB": "2fL9kLFYSCNmKnhLpab50HJAbVx",
  "PUBLIC_SENTRY_DSN_WEB": "https://2a13400a30ad4037a8f0cf127af14bff@o1003299.ingest.sentry.io/5966172",
  "PUBLIC_SENTRY_ENABLE_EVENTS": "true",
  "PUBLIC_SENTRY_PROFILES_SAMPLE_RATE": "0.5",
  "PUBLIC_SENTRY_TRACES_SAMPLE_RATE": "0.005",
  "PUBLIC_SINGULAR_APP_ID_WEB": "",
  "PUBLIC_SINGULAR_SDK_KEY": "",
  "PUBLIC_SINGULAR_SDK_SECRET": "",
  "PUBLIC_SPLASH_BACKGROUND_COLOR": "",
  "PUBLIC_SPLASH_LOGO_URL": "",
  "PUBLIC_SPLASH_LOGO_WIDTH": "",
  "PUBLIC_SPLASH_SCREEN_BACKGROUND_COLOR": "#001D00",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_URL": "https://cdn2.treefortsystems.com/public/aba53a40-4ca8-4f37-b1a3-66ba1169d1b4/uploads/ed42e1b7-2c27-45f5-98f4-ea18c5792a6b.png",
  "PUBLIC_SPLASH_SCREEN_FOREGROUND_IMAGE_WIDTH": "135",
  "PUBLIC_TENANT_ID": "aba53a40-4ca8-4f37-b1a3-66ba1169d1b4",
  "PUBLIC_MAJOR_VERSION": "32",
  "PUBLIC_MINOR_VERSION": "11",
  "PUBLIC_PATCH_VERSION": "2",
  "PUBLIC_SENTRY_DIST": "v0",
  "PUBLIC_SENTRY_RELEASE_WEB": "fortisplus.org@32.11.2",
  "PUBLIC_SPLASH_SCREEN_DISPLAY_MODE": "dark"
}
